import { render } from "./FrontPaper.vue?vue&type=template&id=57da61af"
import script from "./FrontPaper.vue?vue&type=script&lang=js"
export * from "./FrontPaper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__